import { Ban } from "lucide-react";
import { cn } from "../../../utils/utils";

const Avatar = ({ user, showStatus = true, size = "md", className }) => {
  const sizeClasses = {
    sm: "w-8 h-8",
    md: "w-10 h-10",
    lg: "w-12 h-12",
  };

  const statusClasses = {
    online: "bg-green-500",
    offline: "bg-gray-400",
    away: "bg-yellow-500",
  };

  const statusSizes = {
    sm: "w-2 h-2",
    md: "w-2.5 h-2.5",
    lg: "w-3 h-3",
  };

  return (
    <div className={cn("relative rounded-full", className)}>
      <div className={cn("rounded-full overflow-hidden", sizeClasses[size])}>
        {user?.avatar && user?.avatar !== "" ? (
          <img
            src={user.avatar}
            alt={user.name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        ) : user ? (
          <div
            className="w-full h-full object-cover flex items-center justify-center cursor-default"
            title={user?.name}
          >
            {user?.name
              ?.split(" ")
              .map((w) => w[0])
              .slice(0, 2)}
          </div>
        ) : (
          <Ban className="w-full h-full object-cover text-gray-400" />
        )}
      </div>
    </div>
  );
};

export default Avatar;
